
export default () => {
    const btnToTop = document.getElementById('button-to-top');

    if (!btnToTop) return;
    // Add click event listener to the button
    btnToTop.addEventListener('click', () => {
        // Scroll to the top of the page
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}